module.exports = __webpack_public_path__ + "static/media/OTPconfirmImage.8625310c.png";